import { Icon } from '@iconify/react'
import React, { FC } from 'react'
import styled, { css } from 'styled-components'

interface FieldErrorProps {
  code?: string
  message?: string
  show?: boolean
}

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacing(0.5)};
    padding: ${theme.spacing(0.5)};
    font-size: 1.4rem;
    color: #da2f47;

    svg {
      flex-shrink: 0;
    }
  `}
`

const FieldError: FC<FieldErrorProps> = ({ code = '', message = '', show = false }) => {
  if (!show) return null

  return (
    <Wrapper>
      <Icon icon="zondicons:exclamation-outline" fontSize={18} />
      {code && <span>{code}: </span>}
      <span>{message}</span>
    </Wrapper>
  )
}

export default FieldError
